import { t } from "i18next";
import { INode } from "../search/types";
import { IDomain } from "./models/userInfo";

export interface IFavorite {
  node: INode;
  domain: IDomain;
}

export enum dataInterval {
  Hour = "h",
  Day = "d",
  Month = "m",
}
export type Interval = "h" | "d" | "m";

export interface IDomainSetting {
  Name: string;
  Value: string;
}

export enum DeviceType {
  Leakage = 65538,
  Smoke = 26,
  Climate = 27,
  ShellProtection = 65540,
  HotWater = 6,
  ColdWater = 22,
  Electric = 2,
  CO2 = 42,
  Water = 7,
  HeatEnergy = 4,
  HeatCostAllocator = 8,
}
